export interface RawExtensionApiResponse {
  id: string;
  name: string;
  title: string;
  description: string;
  logo_url: string;
  config_schema: object;
  config_data: object | undefined;
  status: ExtensionResponseStatusEnum;
}

export enum ExtensionResponseStatusEnum {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}
